import { EhrWritePath } from "../../../../domain/ehr";
import { CurrentEhr } from "./ehr-context";

/**
 * Function to get the EHR writeback resources for a given EHR.
 * Keep in sync with backend routes and EHR state.
 * Notion reference EHR state: https://www.notion.so/metriport/State-of-EHR-projects-296b51bb904080cf9a17dd98b3c46159
 */
export function getEhrWritebackResources(currentEhr: CurrentEhr): EhrWritePath[] {
  if (currentEhr.isAthena) {
    return [
      "allergy",
      "condition",
      "family-history",
      "immunization",
      "lab",
      "medication",
      "note",
      "procedure",
      "vitals",
    ];
  } else if (currentEhr.isCanvas) {
    return ["allergy", "condition", "immunization", "medication", "vitals"];
  } else if (currentEhr.isElation) {
    return ["condition"];
  } else if (currentEhr.isHealthie) {
    return ["allergy", "condition", "medication"];
  } else if (currentEhr.isEClinicalWorks) {
    return [];
  } else if (currentEhr.isSalesforce) {
    return [];
  } else if (currentEhr.isPracticeFusion) {
    // TODO: use `return ["allergy", "condition", "medication"];` once Practice Fusion team fixes 500
    return [];
  }
  return [];
}

/**
 * Function to check if EHR has and can writeback resources.
 */
export function canWritebackResource(currentEhr: CurrentEhr, path: EhrWritePath): boolean {
  return getEhrWritebackResources(currentEhr).includes(path);
}
